import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div>
      <footer class="footer">
        <div class="footer__addr">
          <div>
            <h1 class="footer__logo">Uttarpurusha Theatre Group</h1>
            <a class="footer__btn" href="mailto:uttarpurush1970@gmail.com">
              Email Us
            </a>
          </div>
          <div>
            <h2>Contact</h2>
            <address>
              Utkal Karate School, 4A, Unit-09, Sachivalay Marg, <br />
              Bhubaneswar-751022
              <br />
            </address>
          </div>
        </div>

        <div class="legal">
          <p>&copy; 2023 Uttarpurusha Theatre Group . All rights reserved.</p>

          <div class="legal__links">
            <h4>
              Designed by{" "}
              <a href="https://zetracx.samnanda.in/" className="ze-logo">
                ZETRACX
              </a>
            </h4>
            <img src="https://formcarry.com/formcarry_form_icon.svg" alt="" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
